import React from 'react';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { LazyIntegrationAutomation } from './async.tsx';

export const IntegrationAutomation = (): React.JSX.Element => (
	<LazyPage
		Page={LazyIntegrationAutomation}
		pageId="async-jira-eoc-integration-automation"
		shouldShowSpinner
	/>
);
